import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); 
  const navigate = useNavigate();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSignup = async () => {
    if (!email || !password || !confirmPassword) {
      setMessageType("error");
      setMessage("Please fill all fields.");
      return;
    }

    if (!emailRegex.test(email)) {
      setMessageType("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    if (password !== confirmPassword) {
      setMessageType("error");
      setMessage("Passwords do not match.");
      return;
    }

    try {
      await createUserWithEmailAndPassword(auth, email, password);
      setMessageType("success");
      setMessage("Signup successful! Redirecting to login...");

      setTimeout(() => navigate("/login"), 2000);
    } catch (error) {
      console.error("Error during signup:", error);
      setMessageType("error");
      setMessage("Failed to signup. Please try again.");
    }
  };

  return (
    <div className="auth-container">
      <form autoComplete="off">
        <h2>Sign Up</h2>
        {message && (
          <p
            className={`message ${messageType}`}
            style={{ color: messageType === "success" ? "green" : "red" }}
          >
            {message}
          </p>
        )}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="auth-input"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="auth-input"
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="auth-input"
        />

        <button type="button" onClick={handleSignup} className="auth-btn">
          Sign Up
        </button>
      </form>
    </div>
  );
};

export default Signup;
